import Genre from '../../ui/Genre/OneCategory';
import classes from './Category.module.css';
import React, { useContext } from 'react';
import {GenreContext} from '../../../store/GenreContext';
import SubCategory from './subCategory/SubCategory';
import CategorySlider from '../../ui/CategorySlider/CategorySlider';


const Category = () => {
  const ctx = useContext(GenreContext);
  const {fetchedCategories,genreOpen,showSubGenre} = ctx;

  
  return (
    <>
    <div className={`contain`}>
      <CategorySlider data={fetchedCategories}>
        {
          fetchedCategories.map((item) => {
            return item.isMenu && <Genre activeId={genreOpen} key={item.id} src={item.iconImage} id={0} label={item.label} /> 
          })
        }
      {
        fetchedCategories.map((item) => 
        !item.isMenu &&
        <Genre activeId={genreOpen} key={item.id} src={item.iconImage} id={item.id} label={item.label} />
        )
      }   
      </CategorySlider>
    </div>
      {showSubGenre && <SubCategory />}
      <div className={classes.borderBottom}></div>   
    </>
  )
}

export default React.memo(Category);